export const REGISTRATION_ENDPOINTS = {
    groups: `/groups?tenant=RANGI`,
    register: `/register`,
};
